import React from 'react';
import { Link } from 'react-router-dom';
import { Settings2, ArrowRight, Hash, GitBranch, FileStack, DatabaseZap } from 'lucide-react';

const ITEMS = [[Hash, 'Part numbering', 'ELE-000123 · 000000124 · SAT-ELE-000125'], [GitBranch, 'Lifecycle & revisions', 'Gated transitions · A→B→C · 1.0→1.1'], [FileStack, 'Document control', 'Per-category schemes & approvals'], [DatabaseZap, 'Data migration', 'Map · dry-run · staged import']];

export const EnterpriseSetupCTA = () => (
  <section className="py-14 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-900" data-testid="home-enterprise-setup">
    <div className="max-w-6xl mx-auto rounded-3xl border border-cyan-500/30 bg-gradient-to-br from-slate-900 via-slate-900 to-cyan-950/50 p-6 md:p-10 grid lg:grid-cols-[1.1fr_1fr] gap-8 items-center shadow-[0_0_60px_-20px_rgba(34,211,238,0.35)]" data-testid="home-enterprise-setup-panel">
      <div>
        <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-cyan-300 font-semibold"><Settings2 className="w-4 h-4" /> Enterprise Setup & Migration</span>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white">Configure Your Enterprise</h2>
        <p className="mt-3 text-sm md:text-base text-slate-400 max-w-xl">Define your part numbering, lifecycle controls, revision standards, and data migration strategy before deployment.</p>
        <Link to="/enterprise-setup" data-testid="home-explore-setup-btn" className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-cyan-500 text-slate-950 text-sm font-semibold hover:bg-cyan-400 transition-colors">
          Explore Enterprise Setup <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {ITEMS.map(([Icon, t, s]) => (
          <div key={t} className="rounded-xl border border-slate-800 bg-slate-950/60 px-4 py-4 hover:border-cyan-500/40 transition-colors">
            <div className="text-sm font-semibold text-white flex items-center gap-2"><Icon className="w-4 h-4 text-cyan-400" />{t}</div>
            <div className="text-[11px] text-slate-500 mt-1 font-mono">{s}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
